import e from "@dialpad/dialtone-tokens/layered/themes/tokens-121-colors.css?inline";
//#region themes/121.js
var t = { brand: {
	css: e,
	name: "121"
} };
//#endregion
export { t as default };
